export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS'; 
export const GET_DASHBOARD_METRICS = 'GET_DASHBOARD_METRICS'
export const UPDATE_ADMIN_CREDENTIALS = 'UPDATE_ADMIN_CREDENTIALS'
export const CREATE_USER = 'CREATE_USER'
export const GET_ALL_USERS = 'GET_ALL_USERS';
export const GET_ALL_APPOINTMENTS = 'GET_ALL_APPOINTMENTS'
export const DELETE_APPOINTMENTS = 'DELETE_APPOINTMENTS'
export const DELETE_USER = 'DELETE_USER'
export const GET_ALL_DOCTORS = 'GET_ALL_DOCTORS'
export const GET_ALL_PATIENTS = 'GET_ALL_PATIENTS';
export const ADD_SPECIALITY = 'ADD_SPECIALITY'; 
export const GET_SPECIALITY = 'GET_SPECIALITY';
export const DELETE_SPECIALITY = 'DELETE_SPECIALITY';
export const EDIT_SPECIALITY = 'EDIT_SPECIALITY';
export const LOGOUT = 'LOGOUT';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const CLEAR_MSG = 'CLEAR_MSG';
export const SET = 'SET';

